import { UserCircleIcon } from '@phosphor-icons/react';
import { Icon } from '@sr/ui-library';
import { ReactNode } from 'react';

interface INameAndImage {
  children?: ReactNode;
  imageUri?: string;
}

// It can be in teammates table and invitation table.
// As long as it needs name with image it can be reuse.
const UserNameAndImage = ({ children, imageUri }: INameAndImage) => {
  return (
    <div className="flex items-center">
      <div className="flex-shrink-0">
        {imageUri ? (
          <img
            alt="Avatar photo"
            className="avatar w-9 rounded-full"
            src={imageUri || ''}
          />
        ) : (
          <Icon className="!size-10 text-read-only-bg" icon={UserCircleIcon} />
        )}
      </div>
      <div className="ml-1">
        {children ? (
          children
        ) : (
          <span className="text-base font-normal italic text-read-only-text opacity-50">
            Name Pending
          </span>
        )}
      </div>
    </div>
  );
};

export default UserNameAndImage;
